<template>
	<footer>
		<div class="footer-element">
			<div class="row main-footer">
				<div class="footerlogo">
					<div class="columns column3">
						<img
							src="~/assets/images/hotel-select-footer-logos/wp-hotels-main-footer.svg"
							loading="lazy"
							alt="WP Hotels & Events"
							class="footer-logo"
						/>
					</div>
				</div>
				<div class="footercolumns">
					<div class="columns column3">
						<h3>{{ defaults[locale].website.hotelName }}</h3>
						<p>
							<!-- <span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
							><br /> -->
							<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span
							><br />
							<span>{{ defaults[locale].website.country }}</span
							><br />
						</p>
					</div>
					<div class="columns column3">
						<h3>{{ $t('contact') }}</h3>
						<p>
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>{{ defaults[locale].website.phone }}</span> </a
							><br />
							<a :href="`mailto:${defaults[locale].website.email}`"
								><span>{{ defaults[locale].website.email }}</span></a
							>
						</p>
						<social-media :socials="socials" />
					</div>
					<div class="columns column3">
						<h3>{{ $t('footerNavigate') }}</h3>
						<p class="footer-nav">
							<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
								{{ item.header }} <br />
							</nuxt-link>
						</p>
					</div>
					<div class="columns column3">
						<h3>{{ $t('events') }}</h3>
						<p class="footer-nav">
							<a href="https://wpevents.be" target="_blank"> WP Events </a> <br />
							<a href="https://wphotels.be" target="_blank"> WP Hotels </a> <br />
							<a href="https://wprealestate.be" target="_blank"> WP Real Estate </a><br />
							<nuxt-link :to="localePath('vacancies')">
								{{ $t('vacancies') }}
							</nuxt-link>
							<br />
						</p>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="columns column12">
					<hr />
				</div>
			</div>
		</div>
		<div class="footer-element author">
			<div class="row">
				<div class="columns column12 align-center">
					<p class="align-right">
						<a :href="$t('siteByUrl')" target="_blank" rel="noopener noreferrer"> Hotel Website Design </a>
						by:
						<a :href="$t('siteByUrl')" target="_blank">
							<img class="siteByLogo" :src="bcLogo" loading="lazy" alt="Site by" />
						</a>
					</p>
					<p class="align-left">
						<span v-for="(item, idx) in bottomfooter[locale]" :key="item.filename">
							<nuxt-link :to="item.filename">
								{{ item.header }}
							</nuxt-link>
							<span v-if="idx < bottomfooter[locale].length - 1"> | </span>
						</span>
						<span>
							<a v-if="defaults[locale].cookieConsent.published" href="#" @click.prevent="openConsent">
								| {{ $t('consentOpen') }}
							</a></span
						>
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
import bcLogo from '@/assets/images/logo-becurious.svg';

const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();
const localePath = useLocalePath();

const { defaults, socials, fetchDefaults } = useDefaults();
const { openConsent } = useCookieConsent();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.main-footer {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

	.footerlogo {
		width: 25%;
		display: flex;
		align-items: start;
		padding-top: 30px;

		.columns {
			width: 100%;
			display: flex;
			padding-left: 0;
		}
	}

	.footercolumns {
		width: 75%;
		display: flex;
		flex-wrap: wrap;

		.column3 {
			padding: 20px;
		}
	}

	h3 {
		font-size: 22px;
		margin-bottom: 10px;
	}

	p {
		font-size: 14px;
		color: #fffbf6;
	}
}

.footer-element {
	background: #041e42;
	color: #fff;
	padding: 45px 0 10px;
	font-size: 15px;
}

.footer-element hr {
	background: #f4f0e7;
}

.footer-element a {
	color: #fff;

	&:hover {
		color: var(--cta-color);
	}
}

.footer-element h3 {
	color: #fff;
	line-height: 1.3;
}

.footer-element.author {
	padding: 10px 0;
	font-size: 12px;
}

.author .column12 {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
}

.author img {
	max-width: 75px;
	margin: 0 1px 0 2px;
	padding-bottom: 3px;
}

.footer-logo {
	width: 100%;
	max-width: 280px;
	margin: 0 0 30px;
}

:deep(.socials a) {
	color: #fff;
	background: none !important;
	place-content: unset;
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 22px;
	margin: 5px 5px 5px 0;
	text-decoration: none;
}

:deep(.socials a):hover {
	color: var(--cta-color);
	background: var(--cta-color);
}

@media (max-width: 920px) {
	.main-footer {
		.footerlogo {
			width: 100%;
			padding-top: 0;

			.columns {
				width: 100%;
				justify-content: center;
			}
		}

		.footercolumns {
			width: 100%;

			.column3 {
				padding: 0 !important;

				:deep(p) {
					margin-bottom: 0 !important;
				}
			}
		}
	}

	.footer-element {
		text-align: center;
	}

	.footer-element .columns {
		margin: 10px auto;
	}

	.author .columns {
		margin: 0;
		flex-flow: wrap column-reverse;
	}

	.author p {
		width: 100%;
		margin: 0 0 5px;
		text-align: center;
	}

	.socials {
		place-content: center;

		:deep(a) {
			place-content: center;
		}
	}
}

@media (max-width: 800px) {
	.footer-element {
		text-align: center;
	}
}
</style>
